<script>
    import {onMount} from "svelte";
    import {GET, POST} from "../../components/communication.js";
    import {formatISODateString2FinDate} from "../../components/utils.js";

    // Viimeisimmät kasket ja savotat
    let groupTrainings = [];
    let kaski = {};
    let savotta = {};

    onMount(async function () {
            const response = GET("/c/getLastGroupTrainings");
            const data = await response;
            groupTrainings = data;

            if (groupTrainings && groupTrainings.length > 0) {
                if (groupTrainings[0].type == "kaski") {
                    kaski = groupTrainings[0];
                }
                if (groupTrainings[1] && groupTrainings[1].type == "kaski") {
                    kaski = groupTrainings[1];
                }
                if (groupTrainings[0].type == "savotta") {

                    savotta = groupTrainings[0];
                }
                if (groupTrainings[1] && groupTrainings[1].type == "savotta") {

                    savotta = groupTrainings[1];
                }
            }

            console.log("onMount :: Haetaan viimeisimmät kasket ja savotat: ", groupTrainings);
        }
    );

</script>

<div class="page">
    <div class="container">
        <div class="row">
            <h3>Viimeisin Syke- ja Voimakaski</h3>
        </div>

        <div class="row">
            {#if kaski && kaski.type === "kaski"}
                <div class="col-xs-12 col-md-6">
                    <h4>Viimeisin Kaskitreeni - {formatISODateString2FinDate(kaski.filename)}</h4>
                    <p>{@html kaski.description}</p>
                </div>
            {/if}
            {#if savotta && savotta.type === "savotta"}
                <div class="col-xs-12 col-md-6">
                    <h4>Viimeisin Savotta - {formatISODateString2FinDate(savotta.filename)}</h4>
                    {@html savotta.description}
                </div>
            {/if}
        </div>
    </div>
</div>

